<template>
  <div class="header">
    <b-navbar v-bind:class="{ 'menu-bg' : isAppear }" toggleable="lg" type="dark">
      <a class="logo" href="#" v-scroll-to="'#top'">
        <img alt="nappalm" src="../assets/logo.gif">
      </a>
      <b-navbar-toggle class="humberger" target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <li class="nav-item">
            <a class="nav-link" href="#" v-scroll-to="'#top'">TOP</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" v-scroll-to="'#brand'">BRAND</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" v-scroll-to="'#shop'">SHOP</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" v-scroll-to="'#company'">COMPANY</a>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      isAppear: false
    }
  }
}
</script>

<style scoped>
.navbar-collapse.collapse {
  justify-content: flex-end;
}
.menu-bg {
  background: black;
  transition: all 0.5s ease;
}
.menu-list {
  margin-top: 20.97px;
}
.humberger {
  border-color: rgba(255, 255, 255, 0.0)!important;
}

.nav-item a {
  color: #FFFFFF;
}
.nav-item {
  padding-left: 47px;
}
.nav-link {
  color: #FFFFFF!important;
  font-size: 18px!important;
}
.header {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  color: #fff;
}
.logo {
  display: block;
  height: 100%;
  width: 100%;
  max-width: 120px;
}

.logo img {
  height: 100%;
  width: auto;
  height: -webkit-fill-available;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue